import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccCatalogItem, OccCatalogParams } from '@catalog/const/v2';
import { HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccCatalogService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  load({ nodeId, level }: OccCatalogParams): Observable<OccCatalogItem> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.menu, { queryParams: { nodeId, level } });

    return this.http.get<OccCatalogItem>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.menu),
    });
  }
}
